import React from "react";
import { genericMapStateToProps, IGenericUserProps } from "../../DataClasses/GenericUser";
import idssStyle from "../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import { Redirect } from "react-router-dom";
import AdministrationService from "../Services/AdministrationService";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import { IAppInfoItem } from "../../DataClasses/AdministrationData";
import { Grid2 as Grid } from "@mui/material";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface IAppInfoStateStore {
  isLoading: boolean;
  redirect: boolean;
  data: IAppInfoItem[];
}

type IStylesProps = WithStyles<typeof styles>;

class AppInfoView extends React.Component<
  IGenericUserProps & IStylesProps,
  IAppInfoStateStore
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      redirect: false,
      data: []
    }
  }

  // Define table columns for app info data
  private getTableColumns = (): ISharedTableColumn<IAppInfoItem>[] => [
    {
      accessorKey: 'key',
      header: 'Key',
      enableSorting: true,
      enableFiltering: true,
      size: 30
    },
    {
      accessorKey: 'value',
      header: 'Value',
      enableSorting: true,
      enableFiltering: true,
    },
  ];

  public componentDidMount() {
    this.RefreshModel();
  }

  private redirectToErrorPage() {
    return <Redirect to='/errorpage' />;
  }

  public render() {
    if (this.state.redirect) {
      return this.redirectToErrorPage();
    }
    const appSettings = this.state.data.filter(x => x.type === 1);
    const dbInfo = this.state.data.filter(x => x.type === 3);
    const sysConfig = this.state.data.filter(x => x.type === 2);
    return (
      <div>
        <Grid size={6}>
          <SharedMaterialReactTable
            data={appSettings}
            columns={this.getTableColumns()}
            title="App Settings"
            isLoading={this.state.isLoading}
            enablePagination={true}
            enableSorting={true}
            enableFiltering={true}
            enableColumnActions={true}
            enableRowActions={false}
            layoutMode="fixed"
            initialState={{
              pagination: { pageIndex: 0, pageSize: 8 },
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [8, 10, 15, 20, 25, 50, 75, 100, 500, 1000],
            }}
            emptyMessage="No app settings found."
          />
        </Grid>
        <br />
        <SharedMaterialReactTable
          data={dbInfo}
          columns={this.getTableColumns()}
          title="DB Info"
          isLoading={this.state.isLoading}
          enablePagination={true}
          enableSorting={true}
          enableFiltering={true}
          enableColumnActions={true}
          enableRowActions={false}
          layoutMode="fixed"
          initialState={{
            pagination: { pageIndex: 0, pageSize: 8 },
          }}
          muiPaginationProps={{
            rowsPerPageOptions: [8, 10, 15, 20, 25, 50, 75, 100, 500, 1000],
          }}
          emptyMessage="No DB info found."
        />
        <br />
        <SharedMaterialReactTable
          data={sysConfig}
          columns={this.getTableColumns()}
          title="Sys Configuration"
          isLoading={this.state.isLoading}
          enablePagination={true}
          enableSorting={true}
          enableFiltering={true}
          enableColumnActions={true}
          enableRowActions={false}
          layoutMode="fixed"
          initialState={{
            pagination: { pageIndex: 0, pageSize: 8 },
          }}
          muiPaginationProps={{
            rowsPerPageOptions: [8, 10, 15, 20, 25, 50, 75, 100, 500, 1000],
          }}
          emptyMessage="No sys configuration found."
        />
      </div>
    );
  }

  private async RefreshModel() {
    this.setState({ isLoading: true });
    const retval = await firstValueFrom(
      AdministrationService.GetAppInfo$(this.props.user)
    );
    if (retval instanceof AjaxError || !retval) {
      this.setRedirectState();
    } else {
      this.setState({ data: retval });
    }
    this.setState({ isLoading: false });
  }

  private setRedirectState() {
    this.setState({ redirect: true });
  }
}

// REDUX CONTAINER
const AppInfoPageWithState = connect<IGenericUserProps>(
  genericMapStateToProps
)(AppInfoView);

// STYLES CONTAINER
const AppInfoPage = withStyles(styles)(
  AppInfoPageWithState
);

export default AppInfoPage;
